<template>
  <div class="hospitalsDetail">
    <div
      class="hospitalsDetail_main"
      :class="{ '-narrow': !state.showPrevBtn }"
    >
      <button
        type="button"
        class="hospitalsDetail_main_back"
        v-if="state.showPrevBtn"
        @click="pageBack"
      >
        戻る
      </button>
      <div
        class="hospitalsDetailHead"
        :class="{ '-narrow': !state.showPrevBtn }"
      >
        <img
          v-if="detail.basicinfo_image1"
          :src="detail.basicinfo_image1"
          :alt="detail.hospital_name"
          class="hospitalsDetailHead_img"
        />
        <img
          v-else
          src="@/assets/images/common/noimg.svg"
          :alt="detail.hospital_name"
          class="hospitalsDetailHead_img"
        />
        <button
          type="button"
          class="hospitalsDetailHead_fav"
          :class="{ '-active': isFavoriteHospital }"
          @click="toggleFavorite"
        ></button>
        <a
          v-if="isParticipateEvent"
          href="/events/"
          @click.prevent="clickTab(2, true)"
          class="hospitalsDetailHead_fes"
        >
          イベント出展予定！
        </a>
      </div>

      <h1 class="hospitalsDetail_ttl">
        {{ detail.hospital_name }}
      </h1>
      <div class="hospitalsDetail_summary">
        <HospitalLabel :isLarge="true" :items="labels" />
        <dl class="hospitalsDetail_summary_data">
          <dt>所在地</dt>
          <dd>{{ detail.prefectures }}{{ detail.hospital_address }}</dd>
          <dt>病院の種別</dt>
          <dd>{{ detail.hospital_class }}</dd>
          <template v-if="detail.departments">
            <dt>診療科目</dt>
            <dd>{{ detail.departments.join('、') }}</dd>
          </template>
        </dl>
        <HospitalTag
          class="hospitalsDetail_summary_feature"
          :tags="features"
          lg
        />
      </div>
    </div>

    <div id="hospitalsDetailCnt" class="hospitalsDetailFlex">
      <div id="menu-before"></div>
      <div id="hospitalsDetailMenuWrap" class="hospitalsDetail_menuWrap">
        <nav
          class="hospitalsDetail_menu"
          :class="{
            'is-fixed': state.fixed,
            'is-hidden-tab': state.hiddenTab
          }"
        >
          <div class="hospitalsDetail_menuInner">
            <Tab
              :list="tab"
              :current="state.currentTab"
              :isPC="true"
              @click-tab="clickTab"
            />
          </div>

          <div class="hospitalsDetail_localNav">
            <ul class="hospitalsDetail_localNav_list">
              <template v-for="(item, i) in localNav">
                <li :key="i" v-if="item.label">
                  <a
                    :href="`#${item.id}`"
                    @click="scrollContents(item.id, $event)"
                  >
                    {{ item.label }}
                  </a>
                </li>
              </template>
            </ul>
          </div>
        </nav>
      </div>

      <div class="hospitalsDetailMain">
        <HospitalsDetailTabAbout
          v-if="state.currentTab === 0"
          :detail="detail"
          :state="state"
          :features="features"
          @click-favorite="toggleFavorite"
        />
        <HospitalsDetailTabEarly
          v-if="tab[state.currentTab].name === 'early'"
          :detail="detail"
        />
        <HospitalsDetailTabLatterList
          v-if="currentlatterPage === 'list'"
          :list="detail.specialist"
          :showLatterDetail="showLatterDetail"
        />
        <HospitalsDetailTabLatterDetail
          v-if="currentlatterPage === 'detail'"
          :hospitalName="detail.hospital_name"
          :hospitalId="detail.hospital_id"
          :paidFlg="detail.paid_flg === 1"
          :data="currentlatterDetailData"
          :list="detail.specialist"
          :showLatterList="showLatterList"
          :showLatterDetail="showLatterDetail"
          @update="getLatterDetailLocalNav"
        />
        <HospitalsDetailTabEvents
          v-if="tab[state.currentTab].name === 'events'"
          :data="data"
          :state="state"
          :features="features"
        />
      </div>

      <div class="hospitalsDetailSide">
        <div
          class="hospitalsDetailSide_inner"
          v-if="currentlatterPage !== 'list'"
        >
          <div class="hospitalsDetailSide_box">
            <div class="hospitalsDetailSide_box_ttl">
              {{ detail.hospital_name }}
            </div>
            <HospitalLabel
              class="hospitalsDetailSide_box_label"
              :items="labels"
            />
            <HospitalContactBtn
              position="side"
              :type="currentlatterPage === 'detail' ? 'latter' : 'default'"
              :id="detail.hospital_id"
              :sTrainingId="
                currentlatterDetailData
                  ? currentlatterDetailData.s_training_id
                  : 0
              "
              :sTrainingName="
                currentlatterDetailData ? currentlatterDetailData.program : ''
              "
              :is-vertical="true"
              :paid-flg="detail.paid_flg === 1"
              @click-favorite="toggleFavorite"
            />
          </div>

          <ul class="hospitalsDetailSide_nav">
            <template v-for="(item, i) in localNav">
              <li :key="i" v-if="item.label">
                <a
                  :href="`#${item.id}`"
                  @click="scrollContents(item.id, $event)"
                >
                  {{ item.label }}
                </a>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>

    <div class="hospitalsDetailCnt_bottomTab">
      <div class="hospitalsDetail_menuInner">
        <Tab
          :list="tab"
          :current="state.currentTab"
          :isPC="true"
          @click-tab="clickTab"
        />
      </div>
    </div>
  </div>

  <aside class="hospitalsDetailAside" v-if="hasRecommend">
    <div class="hospitalsDetailAside_inner u-containar">
      <h4 class="hospitalsDetailAside_ttl">
        {{
          currentlatterPage === 'detail'
            ? '近くの同じ専門科のプログラム'
            : '近隣エリアのおすすめの病院'
        }}
      </h4>
      <ul class="hospitalsDetailAside_list">
        <template v-if="currentlatterPage === 'detail'">
          <HospitalProgramCassette
            v-for="item in recommendPrograms"
            class="hospitalsDetailAside_listItem"
            :key="item.hospital_id"
            :data="item"
          />
        </template>
        <template v-if="currentlatterPage !== 'detail'">
          <HospitalCassette
            v-for="item in recommendHospitals"
            class="hospitalsDetailAside_listItem"
            column2
            :key="item.hospital_id"
            :detail="item"
          />
        </template>
      </ul>
    </div>
  </aside>
</template>

<script lang="ts">
import { reactive, computed, onMounted, watch, ref, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
// import store from '@/store/'
import Tab from '@/components/elements/Tab.vue'
import HospitalLabel from '@/components/elements/HospitalLabel.vue'
import HospitalTag from '@/components/elements/HospitalTag.vue'
import HospitalContactBtn from '@/components/block/HospitalContactBtn.vue'
import HospitalCassette from '@/components/block/HospitalCassette.vue'
import HospitalProgramCassette from '@/components/block/HospitalProgramCassette.vue'
import HospitalsDetailTabAbout from '@/components/block/HospitalsDetailTabAbout.vue'
import HospitalsDetailTabEarly from '@/components/block/HospitalsDetailTabEarly.vue'
import HospitalsDetailTabLatterDetail from '@/components/block/HospitalsDetailTabLatterDetail.vue'
import HospitalsDetailTabLatterList from '@/components/block/HospitalsDetailTabLatterList.vue'
import HospitalsDetailTabEvents from '@/components/block/HospitalsDetailTabEvents.vue'
import { axiosSetting } from '@/utils/axiosSetting'
import { setDetailDocumentTitle } from '@/utils/hospitals/setDetailDocumentTitle'
import smoothscroll from 'smoothscroll-polyfill'
import { Hospital, Specialist, SpecialistCassete } from '@/types/HospitalDetail'
import { ActionHistory } from '@/types/StoreState'

export default defineComponent({
  name: 'hospitalsDetail',

  components: {
    Tab,
    HospitalLabel,
    HospitalTag,
    HospitalContactBtn,
    HospitalCassette,
    HospitalProgramCassette,
    HospitalsDetailTabAbout,
    HospitalsDetailTabEarly,
    HospitalsDetailTabLatterList,
    HospitalsDetailTabLatterDetail,
    HospitalsDetailTabEvents
  },

  props: {
    detail: {
      type: Object,
      default: () => ({})
    }
  },

  beforeRouteEnter: async (to: any, from: any, next: any) => {
    const getDetail = axiosSetting('app', 'page')
    const data = await getDetail
      .get(`/api/v1/detail?hospital_id=${to.params.id}`)
      .then((res) => res.data)
      .catch(() => 'error')

    if (data === 'error') return next('/500')
    if (!data.hospital_name) return next('/404')

    if (to.meta.breadCrumb.length <= 1) {
      to.meta.breadCrumb.push({ label: data.hospital_name })
    } else {
      to.meta.breadCrumb[1] = { label: data.hospital_name }
    }

    setDetailDocumentTitle(data)

    to.matched[0].props.default = {
      detail: data
    }

    next()
  },

  beforeRouteUpdate: async (to: any) => {
    const getDetail = axiosSetting('app', 'page')
    const data = await getDetail
      .get(`/api/v1/detail?hospital_id=${to.params.id}`)
      .then((res) => res.data)

    if (to.meta.breadCrumb.length <= 1) {
      to.meta.breadCrumb.push({ label: data.hospital_name })
    } else {
      to.meta.breadCrumb[1] = { label: data.hospital_name }
    }

    setDetailDocumentTitle(data)

    to.matched[0].props.default = {
      detail: data
    }
  },

  setup(props) {
    smoothscroll.polyfill()
    const route = useRoute()
    const state = reactive({
      fixed: false,
      hiddenTab: false,
      showPrevBtn: false,
      currentTab: 0
    })
    const store = useStore()
    const eventHospitalIds = store.getters['eventHospitalIds']
    const isParticipateEvent = store.getters['isParticipateEvent'](
      `${route.params.id}`
    )

    const tab = computed(() => {
      const list = [
        {
          label: '病院基本情報',
          name: ''
        }
      ]
      if (props.detail.training_id) {
        list.push({
          label: '初期研修情報',
          name: 'early'
        })
      }
      if (props.detail.specialist?.length) {
        list.push({
          label: '専門研修',
          name: 'latter'
        })
      }
      if (isParticipateEvent) {
        list.push({
          label: '参加イベント',
          name: 'events'
        })
      }
      return list
    })

    const judgeCurrentTab = () => {
      const index = tab.value.findIndex((item) => item.name == route.query.tab)
      return index > 0 ? index : 0
    }

    const currentlatterPage = ref('')
    const currentlatterDetailId = ref('')

    const setCurrentlatterPage = (tab: string, id: string) => {
      if (tab !== 'latter') {
        currentlatterPage.value = ''
      } else if (id) {
        currentlatterPage.value = 'detail'
        currentlatterDetailId.value = id
      } else {
        currentlatterPage.value = 'list'
      }
    }
    setCurrentlatterPage(route.query.tab as string, route.query.id as string)

    const currentlatterDetailData = computed(
      (): Specialist => {
        return props.detail.specialist.find(
          (item: Specialist) =>
            String(item.s_training_id) === currentlatterDetailId.value
        )
      }
    )

    // タブの位置にスクロール
    const moveTabHeader = (smooth = false) => {
      const cnt = document.getElementById('hospitalsDetailCnt')
      if (!cnt) return

      const cntYOffset = window.pageYOffset + cnt.getBoundingClientRect().top

      if (window.scrollY > cntYOffset || smooth) {
        const behavior = smooth ? 'smooth' : 'auto'
        window.scrollTo({
          top: cntYOffset,
          behavior: behavior
        })
      }
    }

    const latterDetailLocalNav: any = ref([])
    const getLatterDetailLocalNav = (nav: { id: string; label: string }[]) => {
      latterDetailLocalNav.value = nav
    }

    const localNav = computed(() => {
      if (tab.value[state.currentTab].name === '') {
        return [
          { id: 'about', label: '概要' },
          {
            id: 'basicinfo1',
            label:
              props.detail.basicinfo1_title && props.detail.basicinfo1_body
                ? props.detail.basicinfo1_title
                : ''
          },
          { id: 'feature', label: '特徴' },
          {
            id: 'basicinfo2',
            label:
              props.detail.basicinfo2_title && props.detail.basicinfo2_body
                ? props.detail.basicinfo2_title
                : ''
          },
          { id: 'data', label: '病院情報詳細' },
          { id: 'access', label: 'アクセス' },
          {
            id: 'basicinfo3',
            label:
              props.detail.basicinfo3_title && props.detail.basicinfo3_body
                ? props.detail.basicinfo3_title
                : ''
          }
        ]
      }
      if (tab.value[state.currentTab].name === 'early') {
        return [
          {
            id: 'traininginfo1',
            label:
              props.detail.traininginfo1_title &&
              props.detail.traininginfo1_body
                ? props.detail.traininginfo1_title
                : ''
          },
          { id: 'recruit', label: '募集要項' },
          { id: 'salary', label: '給与・勤務体系' },
          { id: 'training', label: '研修制度・福利厚生' },
          {
            id: 'traininginfo2',
            label:
              props.detail.traininginfo2_title &&
              props.detail.traininginfo2_body
                ? props.detail.traininginfo2_title
                : ''
          },
          { id: 'contact', label: '連絡先' },
          {
            id: 'traininginfo3',
            label:
              props.detail.traininginfo3_title &&
              props.detail.traininginfo3_body
                ? props.detail.traininginfo3_title
                : ''
          }
        ]
      }
      if (currentlatterPage.value === 'detail') {
        return latterDetailLocalNav.value
      }
      return []
    })

    const features = computed(() => {
      const currentkeywords = props.detail.discerning_conditions
        ? props.detail.discerning_conditions
        : []

      return store.state.master.keywords.map((el: any) => {
        return {
          label: el.option_name,
          disabled: currentkeywords.indexOf(el.option_name) === -1
        }
      })
    })

    const labels = computed(() => {
      const res = []
      if (props.detail.prefectures) res.push(props.detail.prefectures)
      if (props.detail.training_id) res.push('初期研修')
      if (props.detail.specialist.length) res.push('専門研修')
      return res
    })

    // おすすめ病院・専門研修
    // ---------------------------

    const ajax = axiosSetting('app', 'block')
    const initializedRecommendHospitals = ref(false)
    const recommendHospitals: Hospital[] = reactive([])
    const recommendPrograms: SpecialistCassete[] = reactive([])

    const getRecommendHospitals = () => {
      const url = `/api/v1/j_search/recommend?prefectures=${props.detail.prefectures_code}`
      ajax.get<Hospital[]>(url).then((res) => {
        recommendHospitals.splice(0)
        res.data.forEach((item: Hospital) => {
          if (item.hospital_id === Number(route.params.id)) return
          if (recommendHospitals.length >= 3) return
          recommendHospitals.push(item)
        })
        initializedRecommendHospitals.value = true
      })
    }
    const getRecommendPrograms = (sId: string) => {
      const url = `/api/v1/j_search/specialist_near_area?s_training_id=${sId}`
      ajax.get<SpecialistCassete[]>(url).then((res) => {
        recommendPrograms.splice(0)
        res.data.forEach((item: SpecialistCassete) => {
          if (recommendPrograms.length >= 3) return
          recommendPrograms.push(item)
        })
      })
    }

    const hasRecommend = computed(() => {
      return (
        (currentlatterPage.value === 'detail' && recommendPrograms.length) ||
        (currentlatterPage.value !== 'detail' && recommendHospitals.length)
      )
    })

    const getRecommend = () => {
      if (currentlatterPage.value === 'detail') {
        getRecommendPrograms(currentlatterDetailId.value)
      } else {
        getRecommendHospitals()
      }
    }

    // お気に入り関連
    // ---------------------------

    // お気に入りに追加済みかどうか
    const isFavoriteHospital = computed(() => {
      if (!store.state.isLogin) return false

      return store.state.userInfo.favorite_history.some(
        (el: ActionHistory) => el.hospital_id === Number(route.params.id)
      )
    })

    // お気に入りの追加・削除
    const toggleFavorite = () => {
      if (isFavoriteHospital.value) {
        store.dispatch('removeFavorite', { id: Number(route.params.id) })
      } else {
        store.dispatch('addFavorite', { id: Number(route.params.id) })
      }
    }

    // イベント関連
    // ---------------------------
    const data = reactive({
      eventList: [] as any[]
    })

    // イベント参加病院かどうか判定
    const setEventStatus = async () => {
      if (!eventHospitalIds) return

      // イベント参加病院であればイベント情報を取得する
      if (!isParticipateEvent) return

      if (route.query.tab === 'events') {
        state.currentTab = tab.value.findIndex((item) => item.name == 'events')
      }

      const res = await axiosSetting('cms', 'block').get(
        `${process.env.VUE_APP_WPAPI_URL}wp-json/mynaviresident/v1/event?hospital_id=${route.params.id}`
      )

      if (!res.data) {
        data.eventList = [] // 参加イベントリストをリセット
        return
      }

      // NOTE: 状態の書き換えを1回で終わらせるためmapメソッドに変更
      data.eventList = res.data.data
        .map((event: any) => {
          if (event.cast_type.length == 0) return event
          return {
            ...event,
            cast_type: event.cast_type.map((type: 'live' | 'recorded') => ({
              value: type,
              label: type === 'live' ? 'LIVE配信あり' : '録画配信あり'
            }))
          }
        })
        .filter((event: any, idx: number, orig: any[]) => {
          // NOTE: 最初に見つかったid以外は重複とみなして取り除く
          const idxThis = orig.indexOf(event)
          const idxFirst = orig.findIndex((e: any) => e.id == event.id)
          return idxThis === idxFirst
        })
    }

    // タブ遷移 / 専門研修遷移関連
    // ---------------------------

    // タブ操作
    const clickTab = (i: number, smooth = false) => {
      state.currentTab = i
      const id = route.params.id as string
      const q = i === 0 ? id : `${id}?tab=${tab.value[i].name}`
      history.replaceState(null, '', q)

      setCurrentlatterPage(tab.value[i].name, '')
      moveTabHeader(smooth)
      setDetailDocumentTitle(props.detail)

      if (!initializedRecommendHospitals.value) getRecommendHospitals()
    }

    const showLatterList = () => {
      const latterTab = tab.value.findIndex((item) => item.name == 'latter')
      clickTab(latterTab)
    }

    const showLatterDetail = (s_training_id: number) => {
      state.currentTab = tab.value.findIndex((item) => item.name == 'latter')
      const id = route.params.id as string
      const q = `${id}?tab=latter&id=${s_training_id}`
      history.replaceState(null, '', q)
      setCurrentlatterPage('latter', String(s_training_id))
      setDetailDocumentTitle(props.detail)
      moveTabHeader()
      getRecommendPrograms(String(s_training_id))
    }

    // 戻るの制御
    // ---------------------------
    const showPrevBtn = () => {
      const referrer = document.referrer
      if (referrer && history.state.back) {
        const domain = window.location.protocol + '//' + window.location.host
        if (referrer.indexOf(domain) === 0) {
          state.showPrevBtn = true
        }
      }
    }

    const pageBack = () => window.history.back()

    // ページの描画と更新時に実行したい処理
    const pageInit = () => {
      getRecommend()
      setEventStatus()
      showPrevBtn()
      state.currentTab = judgeCurrentTab()
    }
    pageInit()

    // ページが更新された時に実行
    watch(
      () => route.params.id,
      () => {
        if (route.name === 'HospitalsDetail') {
          pageInit()
        }
      }
    )

    watch(
      () => store.state.eventParticipatingHospitals,
      (value) => {
        if (!value) return
        setEventStatus()
      }
    )

    // コンテンツのアンカーリンク
    const scrollContents = (anchor: string, e: any) => {
      e.preventDefault()

      const el = document.getElementById(anchor)

      if (el) {
        const pos = el.offsetTop - 110

        window.scrollTo({
          top: pos,
          behavior: 'smooth'
        })
      }
    }

    onMounted(async () => {
      // メニューがposition: sticky で固定された時にclassを付与
      const menu = document.getElementById('hospitalsDetailMenuWrap')
      const menuBefore = document.getElementById('menu-before')
      if (menu && menuBefore) {
        const observer = new IntersectionObserver((entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              menu.classList.remove('is-fixed')
            } else {
              menu.classList.add('is-fixed')
            }
          }
        })
        observer.observe(menuBefore)
      }
    })

    return {
      state,
      tab,
      localNav,
      labels,
      features,
      isParticipateEvent,
      isFavoriteHospital,
      currentlatterPage,
      currentlatterDetailData,
      clickTab,
      showLatterList,
      showLatterDetail,
      getLatterDetailLocalNav,
      pageBack,
      toggleFavorite,
      scrollContents,
      recommendHospitals,
      recommendPrograms,
      hasRecommend,
      data
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hospitalsDetail {
  &_main {
    background: #fff;
    position: relative;

    @include mixins.media() {
      padding-top: 84px;
      max-width: 1128px;
      margin-right: auto;
      margin-left: auto;
      padding-right: 20px;
      padding-left: 20px;

      &.-narrow {
        padding-top: 44px;
      }
    }

    &_back {
      position: absolute;
      font-size: 1.4rem;
      left: 16px;
      top: 16px;
      display: flex;
      align-items: center;
      color: #fff;
      z-index: 2;
      @include mixins.media() {
        color: var.$color-main;
        top: 24px;
        left: 20px;
      }

      &::before {
        content: '';
        display: block;
        width: 11px;
        height: 20px;
        background-image: url('~@/assets/icon/arrow-left.svg');
        background-size: 11px 20px;
        margin-right: 10px;
        @include mixins.media() {
          background-image: url('~@/assets/icon/arrow-left-main.svg');
        }
      }
    }
    // padding-bottom: 15px;
  }

  &_ttl {
    font-size: 2.2rem;
    font-weight: 500;
    line-height: 1.5;
    padding: 16px;
    @include mixins.media() {
      font-size: 2.4rem;
      padding: 0;
      padding-bottom: 16px;
      @include mixins.pcWidth(600);
    }
  }

  &_summary {
    display: none;
    @include mixins.pcWidth(600);
    padding-bottom: 50px;
    @include mixins.media() {
      display: block;
    }
    &_data {
      margin-top: 23px;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 28px;
      dt {
        font-weight: 500;
        flex-basis: 16.1%;
        max-width: 16.1%;
      }
      dd {
        flex-basis: 83.9%;
        max-width: 83.9%;
      }
    }
  }

  &_menuWrap {
    height: 130px;
    position: sticky;
    top: 0;
    z-index: 11;

    @include mixins.media() {
      width: 100%;
      height: 0;
      margin-bottom: 104px;
    }
  }

  &_menu {
    background: #fff;
    transition: top 0.3s;
    position: relative;

    &.is-fixed {
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.08);
      width: 100vw;
      padding-bottom: 0;

      .hospitalsDetail_menu_btns {
        display: none;
      }
    }

    .hospitalsDetail_menu_btns {
      display: none;
      position: absolute;
      top: 11px;
      right: 20px;
      @include mixins.media() {
        display: flex;
      }
    }
  }

  &_menuInner {
    position: relative;

    @include mixins.media() {
      padding-right: 20px;
      padding-left: 20px;
      margin-left: auto;
      margin-right: auto;
      max-width: 1128px;
    }
  }

  &_localNav {
    width: 100%;
    // display: flex;
  }

  &_localNav_list {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    padding-left: 6px;
    padding-right: 6px;
    @include mixins.media() {
      display: none;
    }

    > li > a {
      display: flex;
      padding: 0 10px;
      height: 60px;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      &::after {
        content: '';
        display: block;
        width: 11px;
        height: 8px;
        background-image: url('~@/assets/icon/arrow-down.svg');
        background-size: 11px 8px;
      }
    }
  }
}

#menu-before {
  background-color: #fff;
  height: 1px;
  width: 100%;
}

.hospitalsDetailHead {
  height: 287px;
  padding-bottom: 16px;
  position: relative;
  background-color: #f5f5f5;

  @include mixins.media() {
    position: absolute;
    top: 90px;
    right: 20px;
    padding-bottom: 0;
    width: calc(430 / 1128 * 100%);

    &.-narrow {
      top: 50px;
    }
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    width: 100%;
    height: 45px;
    background: linear-gradient(#000 0%, rgba(0, 0, 0, 0) 100%);
    opacity: 0.2;
    @include mixins.media() {
      display: none;
    }
  }

  &_img {
    width: 100%;
    height: 287px;
    object-fit: cover;
    @include mixins.media() {
    }
  }

  &_fav {
    position: absolute;
    right: 16px;
    top: 16px;
    @include mixins.media() {
      display: none;
    }

    &::before {
      content: '';
      display: block;
      width: 24px;
      height: 22px;
      background-image: url('~@/assets/icon/heart.svg');
      background-size: 24px 22px;
    }

    &.-active::before {
      background-image: url('~@/assets/icon/heart_on.svg');
      background-size: 24px 22px;
    }
  }

  &_fes {
    position: absolute;
    right: 16px;
    bottom: 16px;
    height: 50px;
    border-radius: 10px;
    background: linear-gradient(to right, #ffe869, #caf58f);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    color: #444;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 1.4;
    display: flex;
    align-items: center;
    padding-left: 14px;
    padding-right: 34px;
    overflow: hidden;

    &::before {
      content: '';
      display: block;
      background: var.$color-main;
      height: 50px;
      width: 20px;
      position: absolute;
      right: 0;
    }

    &::after {
      content: '';
      display: block;
      width: 8px;
      height: 14px;
      background-image: url('~@/assets/icon/arrow-right.svg');
      background-size: 8px 14px;
      position: absolute;
      right: 6px;
    }
  }
}

.hospitalsDetailFlex {
  @include mixins.media() {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    // position: relative;
    padding-bottom: 80px;
  }
}

.hospitalsDetailMain {
  @include mixins.media() {
    @include mixins.pcWidth(806);
    width: 76.7%;
    max-width: 866px;
    padding-left: 20px;
    padding-right: 40px;
    margin-bottom: -48px;
  }
}

.hospitalsDetailSide {
  display: none;
  @include mixins.media() {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex: 1;
    background-color: #fff;
    position: sticky;
    top: 104px;
    right: 0;
    width: 33.3%;
    max-width: 262px;
    padding-right: 20px;

    &_box {
      padding: 20px 20px 15px;
      background-color: #fff;
      border-radius: 5px;
      box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);

      &_ttl {
        margin-bottom: 14px;
        line-height: 1.5;
      }
      &_label {
        margin-bottom: 20px;
      }
    }
    &_nav {
      margin-top: 30px;
      li {
        a {
          display: block;
          border-bottom: 1px solid var.$color-border-gray;
          font-size: 1.4rem;
          line-height: 1;
          padding: 15.5px 0;
        }
        &:first-child {
          border-top: 1px solid var.$color-border-gray;
        }
        &.current {
          color: var.$color-main-text;
        }
      }
    }
  }
}

.hospitalsDetailCnt_bottomTab {
  width: 100%;
  margin-bottom: 40px;

  @include mixins.media() {
    margin-bottom: 80px;
  }
}

.hospitalsdetailSection_text ::v-deep a {
  color: #30bab2;
}

.hospitalsDetailAside {
  padding-top: 30px;
  padding-bottom: 40px;
  background-color: #e7f8f6;

  @include mixins.media() {
    padding-top: 44px;
    padding-bottom: 48px;
  }

  &_ttl {
    font-weight: 500;
    font-size: 2rem;
    line-height: 1.5;
  }

  &_list {
    @include mixins.media() {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }
  }

  &_listItem {
    margin-top: 16px;

    @include mixins.media() {
      flex-basis: calc(50% - 20px);
      max-width: calc(50% - 20px);
      margin-top: 24px;

      &:nth-child(even) {
        margin-left: auto;
      }
    }
  }
}

::v-deep(.hospitalsDetailSection_ttl) {
  padding: 10px 16px;
  background-color: #e7f8f6;
  @include mixins.media() {
    font-size: 2rem;
  }
}

::v-deep(.hospitalsDetailSection_cnt) {
  padding: 16px 16px 30px;
  background: #fff;
  position: relative;

  @include mixins.media() {
    padding-bottom: 48px;
  }
}

::v-deep(.hospitalsDetailSection_block) {
  p {
    white-space: pre-line;
  }

  &:not(:first-child) {
    margin-top: 30px;
  }
}

::v-deep(.hospitalsDetailSection_blockTtl) {
  margin-top: 10px;
  margin-bottom: 10px;
}
</style>
